import { ChangeEventHandler } from 'react';

import { LabeledInput } from '../../../../locked-inputs';

import { SimpleCustomFieldProps } from './types';

export function SimpleCustomNumberField(props: SimpleCustomFieldProps) {
  const { onChange, ...others } = props;

  return (
    <LabeledInput
      type="number"
      {...others}
      onChange={
        onChange as ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
      }
    />
  );
}
